import React from 'react';
import {createRoot} from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import {configureStore} from './redux/store';
import {initConfig} from './redux/actions';
import {setupVersionRefresh} from './VersionRefresh';
import {ToastContainer} from 'react-toastify';
import Routes from './routes/Routes';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';

// Theme
import 'rsuite/dist/rsuite.min.css';
import './assets/scss/Saas.scss';

setupVersionRefresh();
const store = configureStore()
store.dispatch(initConfig())

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Don't refetch query data on window focus, it could be too heavy
            refetchOnWindowFocus: false,
        },
    },
})

const root = createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <ToastContainer/>
        <QueryClientProvider client={queryClient}>
            <Routes/>
        </QueryClientProvider>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
